
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "Taxes",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker,
    VueTimepicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      period: "",
      isShow: false,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: "",
      taxable_sale: "",
      non_taxable_sale: "",
      total_sale: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        employee_id: "",
        search: "",
        to_date: "",
        from_date: "",
        to_time: "",
        from_time: ""
      },
      client_id: ""
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.$api
        .getAPI({
          _action: "/report/taxes/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          if (res.taxable_sale) {
            this.taxable_sale = res.taxable_sale;
          } else {
            this.taxable_sale = 0;
          }
          if (res.nontaxable_amount) {
            this.non_taxable_sale = res.nontaxable_amount;
          } else {
            this.non_taxable_sale = 0;
          }
          if (res.net_amount) {
            this.total_sale = res.net_amount;
          } else {
            this.total_sale = 0;
          }

          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_tax_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getPeriod() {
      if (this.period == "Custom Period") {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/report/export_taxes/" +
          this.client_id +
          queryParam
        , _fileName: 'taxes.csv'})
    }
  },
  mounted() {
    this.client_id = localStorage.getItem("client_id");

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-2 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select class="form-control" v-model="period" @change="getPeriod()">
                <option value>{{$lang.messages.all_day}}</option>
                <option>{{$lang.messages.custome_period}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-right row mb-3">
          <div class="text-right col-md-6">
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 120px;"
              v-if="isShow"
            >
              <vue-timepicker
                v-model="filterObj.to_time"
                @change="getList(1)"
                :placeholder="$lang.messages.start_time"
                format="HH:mm"
              ></vue-timepicker>
            </div>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;"
            v-if="isShow"
          >
            <vue-timepicker
              v-model="filterObj.from_time"
              @change="getList(1)"
              :placeholder="$lang.messages.end_time"
              format="HH:mm"
            ></vue-timepicker>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-4 col-lg-4 col-xlg-3">
            <div class="card card-hover">
              <div class="box bg-cyan text-center">
                <h1 class="font-light text-white">
                  <i class="mdi mdi-sale"></i>
                </h1>
                <p class="text-white font-18 mb-0">{{$lang.messages.taxable_sales}}</p>
                <h4 class="text-white h1 f-bold">
                  <vue-numeric
                    v-if="taxable_sale"
                    v-bind:precision="precision"
                    :separator="decimal_separator"
                    :currency="currency"
                    :value="taxable_sale"
                    :read-only="true"
                  ></vue-numeric>
                  <template v-else>0</template>
                </h4>
              </div>
            </div>
          </div>
          <!-- Column -->
          <div class="col-md-4 col-lg-4 col-xlg-3">
            <div class="card card-hover">
              <div class="box bg-success text-center">
                <h1 class="font-light text-white">
                  <i class="mdi mdi-chart-areaspline"></i>
                </h1>

                <p class="text-white font-18 mb-0">{{$lang.messages.non_taxable_sales}}</p>
                <h4 class="text-white h1 f-bold">
                  <vue-numeric
                    v-if="non_taxable_sale"
                    v-bind:precision="precision"
                    :separator="decimal_separator"
                    :currency="currency"
                    :value="non_taxable_sale"
                    :read-only="true"
                  ></vue-numeric>
                  <template v-else>0</template>
                </h4>
              </div>
            </div>
          </div>
          <!-- Column -->
          <div class="col-md-4 col-lg-4 col-xlg-3">
            <div class="card card-hover">
              <div class="box bg-info text-center">
                <h1 class="font-light text-white">
                  <i class="mdi mdi-collage"></i>
                </h1>

                <p class="text-white font-18 mb-0">{{$lang.messages.total_net_sales}}</p>
                <h4 class="text-white h1 f-bold">
                  <vue-numeric
                    v-if="total_sale"
                    v-bind:precision="precision"
                    :separator="decimal_separator"
                    :currency="currency"
                    :value="total_sale"
                    :read-only="true"
                  ></vue-numeric>
                  <template v-else>0</template>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="card-body">
                <div class="pink-tape py-1">
                  <div class="row">
                    <div class="col-lg-9 col-5 pt-1 align-self-center">
                      <a
                        href="javascript:void(0)"
                        class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                        @click="getExport()"
                      >
                        {{$lang.messages.export}}
                        <i class="mdi mdi-download align-text-top"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <table class="table table-striped table-style-1 table-responsive">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">{{$lang.messages.tax_name}}</th>
                      <th scope="col">{{$lang.messages.taxable_sales}}</th>
                      <th scope="col">{{$lang.messages.tax_amount}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in list" :key="item.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{item.name}}</td>
                      <td>
                        <vue-numeric
                          v-if="item.taxable_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.taxable_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td>
                        <vue-numeric
                          v-if="item.tax_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.tax_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
